"use client";

import { EventEnum } from "@sprawdzonabron/shared";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { useAnalyticsEvent } from "../../api/hooks/useAnalyticsEvent";

export const PageVisitCounter = (): null => {
  const postPageVisitEvent = useAnalyticsEvent(EventEnum.PageVisit);
  const pathname = usePathname();

  useEffect(() => {
    postPageVisitEvent(pathname ?? "");
  }, [pathname, postPageVisitEvent]);

  return null;
};
